import { stores } from '../../stores';
import routes from '../constants/routing.constants';
import { isJson } from '../utils/common.utils';
import { MESSAGE_EVENTS } from '../constants/events.constants';
import { metaService } from './meta.service';

const { AuthDone, RedirectMailSent, RedirectTXStatus } = MESSAGE_EVENTS;

class IframeService {
  isInited = false;

  init() {
    if (!this.isInited) {
      window.addEventListener('message', async (ev) => {
        try {
          if (ev.data?.includes?.(AuthDone) && ev.source !== window.self) {
            if (window.top === window.self) {
              /* get session details one more time after authorizing */
              await stores.AuthStore.setSessionMetadata({ restoreId: 'lol' });
              // await metaService.fetchAccountsAndProfile();
              metaService.postAuthRedirect();
            } else {
              // if we are inside landing -> pass msg to top frame
              window.parent.postMessage(ev.data, '*');
            }
          }
          if (ev.data === RedirectMailSent && ev.source !== window.self) {
            window.location = `${
              window.location.origin +
              routes.auth.confirmPassReset.postSent.path
            }?err=null`;
          }
          if (ev.data === RedirectTXStatus) {
            const {
              isFeedbackFormOpened,
              setFeedbackFormOpened,
              setFeedbackFormInvisible,
            } = stores.AppStore;
            if (isFeedbackFormOpened === false) {
              setFeedbackFormOpened(true);
              setFeedbackFormInvisible(false);
            }
          }
          if (
            typeof ev.data === 'string' &&
            isJson(ev.data) &&
            JSON.parse(ev.data.toString()).onSubmit
          ) {
            console.log('Loading event sent by reg service form', 'event');
          }
        } catch (error) {
          console.error(error);
        }
      });
    }
    this.isInited = true;
  }
}

export const iframeService = new IframeService();
